import request from '@/providers/http-service'
const url1 = `${process.env.VUE_APP_API_DOMAIN}`
const url = `${process.env.VUE_APP_API_DOMAIN}/unified-code`

// 删除单条数据
export function notificationDelete(data) {
  return request({
    url: url + '/notification/delete',
    method: 'post',
    data
  })
}

// 查询单条数据
export function notificationDetail(params) {
  return request({
    url: url + '/notification/detail',
    method: 'get',
    params
  })
}

// 添加通知数据
export function notificationAdd(params) {
  return request({
    url: url + '/notification/add',
    method: 'post',
    data: params
  })
}

// 修改通知
export function notificationEdit(params) {
  return request({
    url: url + '/notification/edit',
    method: 'post',
    data: params
  })
}

// 通知分页查询
export function notificationList(params) {
  return request({
    url: url + '/notification/list',
    method: 'post',
    data: params
  })
}


// WEBPACK FOOTER //
// ./src/api/notification.js